"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const MoveArrowDown = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M10.0711 2.24999C10.4853 2.24999 10.8211 2.58578 10.8211 2.99999L10.8211 15.3315L15.4494 10.7031C15.7423 10.4103 16.2172 10.4103 16.5101 10.7031C16.8029 10.996 16.8029 11.4709 16.5101 11.7638L10.6014 17.6725C10.3085 17.9653 9.83364 17.9653 9.54075 17.6725L3.6321 11.7638C3.3392 11.4709 3.3392 10.996 3.6321 10.7031C3.92499 10.4103 4.39986 10.4103 4.69276 10.7031L9.32108 15.3315L9.32108 2.99999C9.32108 2.58578 9.65686 2.24999 10.0711 2.24999Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }) })));
};
MoveArrowDown.displayName = 'MoveArrowDown';
exports.default = MoveArrowDown;
